var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "ul",
      { staticClass: "users" },
      _vm._l(_vm.value, function (account, i) {
        return _c(
          "li",
          [
            _c(
              "md-chip",
              {
                staticClass: "md-primary",
                attrs: { "md-deletable": "" },
                on: {
                  "md-delete": function ($event) {
                    return _vm.removeAccount(i)
                  },
                },
              },
              [_vm._v(_vm._s(account.mail))]
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }